import { render, staticRenderFns } from "./ExchangeList.vue?vue&type=template&id=703c6502&scoped=true"
import script from "./ExchangeList.vue?vue&type=script&lang=js"
export * from "./ExchangeList.vue?vue&type=script&lang=js"
import style0 from "./ExchangeList.vue?vue&type=style&index=0&id=703c6502&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703c6502",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('703c6502')) {
      api.createRecord('703c6502', component.options)
    } else {
      api.reload('703c6502', component.options)
    }
    module.hot.accept("./ExchangeList.vue?vue&type=template&id=703c6502&scoped=true", function () {
      api.rerender('703c6502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/ExchangeList.vue"
export default component.exports